module.exports = __webpack_public_path__ + "img/product_122.ef291f6.webp";